import React, { useCallback } from 'react'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import ToggledInputFields from '../../../../../../common/inputs/toggledInputFields/ToggledInputFields'
import RentalIncomeField from './rentalIncomeField/RentalIncomeField'
import { ToggleSwitchAlignment } from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'

export type RentalIncomeProps = {
  screenId: string
  alignment?: ToggleSwitchAlignment
}

const RentalIncome: React.FC<FieldProps<OtherFacilitiesScreenValidationResult> & RentalIncomeProps> = ({
  insertionData,
  screenName,
  screenId,
  wrapperClassName = 'grid-item one-whole',
  validationMessages,
  onChange,
  doReset,
  alignment,
}) => {
  const onRentedChanged = useCallback(
    (value: boolean) => {
      doReset!([
        {
          screen: screenName,
          property: 'rentalIncome',
        },
      ])
      onChange({ screen: screenName, property: 'rented' }, value)
    },
    [doReset, onChange, screenName]
  )

  return (
    <div className={wrapperClassName}>
      <ToggledInputFields
        screenId={screenId}
        elementId='rental-income'
        propertyName='rented'
        toggleStatus={insertionData.rented ?? false}
        displayChildrenOnToggleState={true}
        customYAxisOffset={0}
        hasRightAlignedToggle={false}
        alignment={alignment}
        onChange={onRentedChanged}
      >
        <RentalIncomeField
          screenId={screenId!}
          rentalIncome={insertionData.rentalIncome}
          rentalIncomeValidation={validationMessages!.rentalIncome ?? []}
          onChange={(property, value) => onChange({ screen: screenName, property }, value)}
        />
      </ToggledInputFields>
    </div>
  )
}

export default RentalIncome
